import { AppStrings } from "./AppStrings";

/**
 * Tier values accepted by PATCH /v1/{user_id}/bet-limits-tier.
 * A user's sportsbook tier is a single value — they are mutually exclusive.
 */
export const SPORTSBOOK_TIERS = {
  DEFAULT: "default",
  VIP: "vip",
  AFFILIATE: "affiliate",
} as const;

export type SportsbookTier =
  (typeof SPORTSBOOK_TIERS)[keyof typeof SPORTSBOOK_TIERS];

export const SPORTSBOOK_TIER_OPTIONS: ReadonlyArray<{
  value: SportsbookTier;
  label: string;
}> = [
  { value: SPORTSBOOK_TIERS.DEFAULT, label: AppStrings.SPORTSBOOK_TIER_DEFAULT },
  { value: SPORTSBOOK_TIERS.VIP, label: AppStrings.SPORTSBOOK_TIER_VIP },
  {
    value: SPORTSBOOK_TIERS.AFFILIATE,
    label: AppStrings.SPORTSBOOK_TIER_AFFILIATE,
  },
];

/** Falls back to "default" when the API returns an unknown/empty tier. */
export const normalizeSportsbookTier = (
  tier: string | null | undefined,
): SportsbookTier => {
  const allowed = Object.values(SPORTSBOOK_TIERS) as string[];
  return allowed.includes(tier as string)
    ? (tier as SportsbookTier)
    : SPORTSBOOK_TIERS.DEFAULT;
};
